import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import SignUp from "./components/auth/signUp";
import ForgotPasscode from "./components/auth/forgotPasscode";
import SignIn from "./components/auth/signIn";
import TypeSelectionPage from "./components/typeSelection/typeSelection";
import GlobalModal from "./components/shared/modals/globalModal";
import PortalSelector from "./components/portalSelector/portalSelector";
import EmailGuard from "./components/shared/EmailGuard";
import ResetPassword from "./components/auth/ResetPassword";
import NotFound from "./components/shared/NotFound";
import MicrosoftCallback from "./components/auth/MicrosoftCallback";
import TermsAndConditions from "./components/legal/TermsPage";
import EmailVerificationExpired from "./components/auth/EmailVerificationExpired";

const AppRoutes = () => (
  <>
    <Routes>
      <Route path="/" element={<Navigate to="/signin" replace />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPasscode />} />
      <Route path="/auth/google/callback" element={<SignUp />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/microsoft/callback" element={<MicrosoftCallback />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/verify-email" element={<EmailVerificationExpired />} />

      <Route
        path="/type-selection"
        element={
          <EmailGuard>
            <TypeSelectionPage />
          </EmailGuard>
        }
      />
      <Route
        path="/portal-selector"
        element={
          <EmailGuard>
            <PortalSelector />
          </EmailGuard>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>

    <GlobalModal />
  </>
);

export default AppRoutes;
